export default function () {

	setTimeout(() => {
		$('table.order-lists-table tbody tr').each((index, row) => {
			const id = $(row).data('order-id');
			const status = $(row).data('order-status');
			const $nameCell = $(row).find('td').eq(1);

			if (status === "Completed") {
				fetch(`/api/storefront/order/${id}`, {credentials: 'include'}) 
				.then(response => response.json()) 
				.then(function(order) {
					if (order && order.lineItems) {
						if (order.lineItems.digitalItems.length > 0) {
							let span = $('<span>', {"class": "download-indicator"}).html('<span class="icon account-product-download"><svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#icon-arrow-down"></use></svg></span>Contains downloadable products');
							$nameCell.append(span);
						}
					}
				});
			}
		})
	}, 1500)
}
